import * as ActionTypes from '../../actions/allActions'

const bookingsInit = { showReviewModal: false }
const bookings = (state = bookingsInit, action) => {
	switch (action.type) {
		case ActionTypes.BOOKINGS_UICHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.LOGOUT:
			return bookingsInit
		default:
			return state
	}
}

export default bookings



// WEBPACK FOOTER //
// ./src/reducers/ui/bookings.js